module.exports = __webpack_public_path__ + "static/media/ро.ba60d1db.mp3";